module.exports = __webpack_public_path__ + "img/yellow.9a1f15ea.png";